import type { ReactElement } from "react";
import { useId } from "react";

import { DropdownButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CountrySelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/CountrySelectCombobox";
import type { ICompanyHeadquarterFilterDto } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { StyledIcon } from "app/pages/sales-intelligence/modules/leads-search-filters/components/DropdownButtonWithIcon/styles";
import { StyledCountryDropdownContainer } from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/styles";
import { COUNTRY_SELECT_WIDTH } from "app/pages/sales-intelligence/modules/leads-search-filters/constants";
import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import type { ICountryObject } from "app/services/CountryService";

import { STATES_DROPDOWN_BUTTON, STATES_DROPDOWN_PLACEHOLDER } from "../const";

interface IStatesDropdownProps {
    states: readonly ICountryObject[];
    value: ICompanyHeadquarterFilterDto | undefined;
    onSelect: (country: { id: number }) => void;
}

export const StatesDropdown = ({ states, value, onSelect }: IStatesDropdownProps): ReactElement => {
    const dropdownId = useId();

    return (
        <StyledCountryDropdownContainer
            id={dropdownId}
            customWidth={COUNTRY_SELECT_WIDTH}
            data-automation="headquarters-states-dropdown"
        >
            <CountrySelectCombobox
                multi
                onSelect={onSelect}
                selectedIds={value?.codes ?? []}
                items={states}
                renderButton={() => (
                    // Inlined so Combobox.Trigger's `asChild` can merge its ref onto this styled.div.
                    <StyledBaseDropdownButtonWrap>
                        <DropdownButton>
                            <StyledIcon iconName="search" />
                            {translate(STATES_DROPDOWN_BUTTON)}
                        </DropdownButton>
                    </StyledBaseDropdownButtonWrap>
                )}
                searchPlaceHolder={translate(STATES_DROPDOWN_PLACEHOLDER)}
            />
        </StyledCountryDropdownContainer>
    );
};
